import { Button } from 'components/elements/button/button'
import { Heading } from 'components/elements/heading/heading'
import {
  DigitalExamResult,
  DigitalExamText,
} from './digitalExamPage.types'

export interface DigitalExamResultsProps {
  result: DigitalExamResult
  text: DigitalExamText
  onRestart: () => void
}

export const DigitalExamResults = ({
  result,
  text,
  onRestart,
}: DigitalExamResultsProps) => {
  return (
    <div className='digital-exam-page__result'>
      <Heading level={2} size='l' className='digital-exam-page__title'>
        {result.passed ? text.passedTitle : text.failedTitle}
      </Heading>
      <dl className='digital-exam-page__summary'>
        <div className='digital-exam-page__summary-row'>
          <dt>{text.correctAnswersLabel}</dt>
          <dd>{result.correctAnswers}</dd>
        </div>
        <div className='digital-exam-page__summary-row'>
          <dt>{text.totalQuestionsLabel}</dt>
          <dd>{result.totalQuestions}</dd>
        </div>
        <div className='digital-exam-page__summary-row'>
          <dt>{text.scorePercentageLabel}</dt>
          <dd>{result.scorePercentage}%</dd>
        </div>
        <div className='digital-exam-page__summary-row'>
          <dt>{text.passingPercentageLabel}</dt>
          <dd>{result.passingPercentage}%</dd>
        </div>
      </dl>
      <Button
        text={text.restartButtonText}
        onClick={() => {
          onRestart()
        }}
        outline
      />
    </div>
  )
}
